export const displayFormModal = (visible) => {
    const formModal = document.querySelector('[data-display-form-visible]');
    if (formModal) {
        formModal.setAttribute('data-display-form-visible', `${visible}`);
    }
    else {
        const formOffset = document.querySelector('[class*=Formstyles__Container]');
        if (formOffset) {
            window.scrollTo({
                top: formOffset.getBoundingClientRect().top + window.scrollY,
                behavior: 'smooth',
            });
        }
    }
};
